import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 36, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children }) => (
  <p className="text-xs uppercase tracking-[0.3em] font-mono text-[#C5A059] mb-6">
    {children}
  </p>
);

export const GoldRule = ({ className = "" }) => (
  <div
    className={`h-px w-16 bg-gradient-to-r from-[#D4AF37] to-transparent ${className}`}
  />
);
